<template>
  <section id="schedule">
    <div class="w-full px-4 pb-6 mx-auto md:px-10">
      <div class="flex flex-col w-full px-4">
        <!-- Active Courses -->
        <div
          v-if="userCourses.length > 0"
          class="flex mb-6 space-x-4 overflow-x-auto md:space-x-8 overscroll-auto"
        >
          <div
            v-for="c in userCourses"
            :key="c.courseId"
            class="relative z-0 px-4 py-4 transition duration-500 ease-in-out transform cursor-pointer hover:scale-95 md:px-8 whitespace-nowrap"
            @click="selectCourse(c.courseId)"
          >
            <span class="mb-1 text-xs capitalize opacity-50 text-fs-700">
              {{ c.name }}
            </span>
            <h4 class="mb-2 uppercase text-fs-700">
              {{ c.trainer }}
            </h4>
            <transition
              enter-active-class="transition duration-200 ease-out"
              enter-from-class="translate-y-1 opacity-0"
              enter-to-class="translate-y-0 opacity-100"
              leave-active-class="transition duration-150 ease-in"
              leave-from-class="translate-y-0 opacity-100"
              leave-to-class="translate-y-1 opacity-0"
            >
              <img
                v-show="c.courseId === selectedCourseId"
                :src="shape2"
                class="absolute w-20 transition duration-500 ease-in-out transform -z-1 -top-2 -left-1 -rotate-6"
              >
            </transition>
          </div>
        </div>

        <!-- Schedule Items -->
        <div class="overflow-hidden bg-white border border-gray-200 rounded-xl">
          <div class="flex-auto">
            <div
              class="flex items-center px-8 py-4 border-b border-gray-100 bg-gray-50"
            >
              <span
                class="text-lg font-medium tracking-wider text-left text-gray-500"
              >
                {{ "Today" | i18n }}, {{ date | date("D MMMM YYYY") }}
              </span>
            </div>
            <ul
              v-if="events.length > 0"
              class="divide-y divide-gray-100"
            >
              <ScheduleItem
                v-for="e in events"
                :key="e.eventId"
                :event="e"
                :foldable-list="true"
              />
            </ul>
            <div
              v-else
              class="grid px-8 py-8 justify-items-center"
            >
              <h4 class="text-lg capitalize text-fs-700">
                {{ "Title_ScheduleEmpty" | i18n }}
              </h4>
              <span class="text-sm capitalize opacity-50 text-fs-700">
                {{ "Subtitle_ScheduleEmpty" | i18n }}
              </span>
              <router-link
                to="/"
                class="block px-6 py-1 mt-5 mb-1 text-center text-white capitalize transition-all duration-150 ease-linear border rounded-lg shadow outline-none bg-fs-500 border-fs-500 hover:bg-fs-600 hover:border-fs-600 hover:shadow-lg focus:outline-none"
              >
                {{ "Button_ScheduleEmpty" | i18n }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ScheduleItem from "@/components/ScheduleItem.vue";

const shape2 = require("@/assets/img/shape-2.png");

export default {
  name: "Schedule",

  components: { ScheduleItem },

  data: () => ({
    shape2,
    date: new Date().toISOString(),
    selectedCourseId: "",
    userCourses: [],
    events: []
  }),

  computed: {
    ...mapGetters(["user", "courses", "activeCourses"])
  },

  created() {
    this.populateData();
  },

  methods: {
    ...mapActions(["fetchEventsByWeek", "fetchEventById"]),
    async getEvents(courseId) {
      this.events = await this.fetchEventsByWeek(courseId);
    },
    async populateData() {
      const userCourses = await this.getUserCourses();
      if (userCourses.length > 0) {
        this.userCourses = userCourses;
        this.selectedCourseId = userCourses[0].courseId;
        this.getEvents(userCourses[0].courseId);
      } else if (this.user.freeEvent.eventId) {
        // if user has free event
        const event = await this.fetchEventById(this.user.freeEvent.eventId);
        this.events.push(event);
      }
    },
    getUserCourses() {
      return this.courses.filter(
        c => this.activeCourses.indexOf(c.courseId) > -1
      );
    },
    selectCourse(courseId) {
      this.selectedCourseId = courseId;
      this.getEvents(courseId);
    }
  }
};
</script>

<style></style>
